<template>
  <b-col
    class="d-flex flex-column"
    style="flex: auto;"
    data-cy="pacientes-container"
  >
    <div class="d-flex flex-row" data-cy="pacientes-header-row">
      <back-button data-cy="pacientes-back-button"></back-button>
      <div class="d-flex flex-column mb-4" data-cy="pacientes-header-info">
        <h4 class="text-primary" data-cy="pacientes-title">
          Selecione
          <b data-cy="pacientes-title-bold">o paciente</b>
        </h4>
        <small class data-cy="pacientes-subtitle">
          Selecione o paciente que deseja
          <b data-cy="pacientes-subtitle-bold">confirmar a consulta</b>
        </small>
      </div>
    </div>

    <search-filter
      placeholder="Buscar paciente..."
      data-cy="pacientes-search-filter"
    ></search-filter>

    <loading-overlay
      v-if="isLoading"
      message="Carregando pacientes..."
      data-cy="pacientes-loading-overlay"
    />
    <div v-else class="row" data-cy="pacientes-list-row">
      <pacient-card
        class="col-12 col-lg-6 mb-4"
        v-for="patient in patients"
        :key="patient.id"
        :paciente="patient"
        :data-cy="`pacientes-card-${patient.id}`"
      ></pacient-card>

      <div
        class="col-12 col-lg-6 mb-4"
        style="cursor: pointer"
        v-b-modal="'modal-new-patient'"
        data-cy="pacientes-add-new-container"
      >
        <div
          class="text-primary d-flex h-100"
          data-cy="pacientes-add-new-inner"
        >
          <div
            class="custom-radio-wrapper w-100 border-dotted border-secondary"
            data-cy="pacientes-add-new-radio-wrapper"
          >
            <span
              class="mx-auto d-inline-flex flex-column align-items-center text-muted justify-content-center"
              data-cy="pacientes-add-new-span"
            >
              <font-awesome-icon
                :icon="['fas', 'plus-circle']"
                size="2x"
                data-cy="pacientes-add-new-icon"
              ></font-awesome-icon>

              <div data-cy="pacientes-add-new-label">
                Adicionar novo
                <b data-cy="pacientes-add-new-label-bold">paciente</b>
              </div>
            </span>
          </div>
        </div>
      </div>

      <patient-new data-cy="pacientes-modal-new"></patient-new>
    </div>
  </b-col>
</template>

<script>
import BackButton from "@/components/back-button.vue";
import SearchFilter from "@/components/filter.vue";
import LoadingOverlay from "@/components/loading-overlay.vue";
import PacientCard from "@/components/paciente-card.vue";
import PatientNew from "@/components/paciente-new.vue";
import { generateTo } from "@/core/routerHelper.js";
import { axiosInstance as Axios } from "@/main";
import { mapGetters } from "vuex";
export default {
  name: "patient",
  components: {
    SearchFilter,
    PacientCard,
    PatientNew,
    BackButton,
    LoadingOverlay
  },
  computed: {
    ...mapGetters("loading", ["isLoading"]),

    patients() {
      return this.$store.getters.get_patients;
    },
    patient_s() {
      return this.$store.getters.get_selected[5];
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.$store.getters.token && to.name.includes("confirmacao")) {
      this.validateRegister(next);
    } else {
      next();
    }
  },
  mounted() {
    this.$store.dispatch("loadclinicifneeded", {
      url: this.$serverHost,
      organizationId: this.$route.params.organizationId
    });

    let payload = {
      organizationId: this.$route.params.organizationId,
      url: this.$serverHost
    };

    this.$store.dispatch("load_patients", payload);

    this.$store.dispatch("set_actual", this.$route.fullPath);
    this.$store.dispatch("set_from", {
      name: generateTo(4, this.$route),
      params: { organizationId: this.$route.params.organizationId },
      query: {
        convenio: this.$route.query.convenio,
        especialidade: this.$route.query.especialidade,
        clinica: this.$route.query.clinica,
        horario: this.$route.query.horario,
        ...(localStorage.getItem("telemedicina")
          ? { telemedicina: localStorage.getItem("telemedicina") }
          : {})
      }
    });

    if (this.patient_s.nome) {
      this.$store.dispatch("set_to", {
        name: generateTo(7, this.$route),
        params: { organizationId: this.$route.params.organizationId },
        query: {
          ...(localStorage.getItem("telemedicina")
            ? { telemedicina: localStorage.getItem("telemedicina") }
            : {})
        }
      });
    } else {
      this.$store.dispatch("set_to", "");
    }
  },
  methods: {
    async validateRegister(next) {
      try {
        let response = await Axios.get(
          `${this.$serverHost}protected/me/campos-pendentes`,
          {
            params: {
              clinica_id: this.$store.getters.get_selected[2].id,
              paciente_id: this.$store.getters.get_selected[5].id
            },
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`
            }
          }
        );

        if (response.data.length > 0) {
          let payload = {
            url: this.$serverHost,
            organizationId: this.$route.params.organizationId,
            redirect: () => {}
          };

          this.$store.dispatch("load_user", payload).then(() => {
            const h = this.$createElement;

            const vNodesMsg = h("p", { class: ["text-center", "mb-0"] }, [
              " Existem alguns dados faltando (" +
                response.data +
                "), por favor, atualize seu cadastro. "
            ]);

            const vNodesTitle = h(
              "div",
              {
                class: ["d-flex", "flex-grow-1", "align-items-baseline", "mr-2"]
              },
              [h("strong", { class: "mr-2" }, "Atualização de Cadastro")]
            );
            // Pass the vNodes as an array for message and title
            this.$bvToast.toast([vNodesMsg], {
              title: [vNodesTitle],
              solid: true,
              variant: "danger",
              autoHideDelay: 15000
            });
            this.$bvModal.show(
              `modaledit-${this.$store.getters.get_selected[5].id}`
            );
          });
          next(false);
        } else {
          next();
        }
      } catch (e) {
        next(false);
      }
    }
  }
};
</script>

<style></style>
